import api from "./apiURL";
export async function getBookingsDetails() {
  try {
    const response = await api.get(`/api/v1/user/bookings`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function onCallTrigger(data) {
  try {
    const response = await api.put(`/api/v1/admin/visit/oncall`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getUnassignedHCPNames() {
  try {
    const response = await api.get(`/api/v1/admin/specialist/names`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function assignHCP(data) {
  try {
    const response = await api.put(`/api/v1/admin/visit/assign`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
